import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SearchableMultiSelectComponent } from '../../../shared/searchable-multi-select/searchable-multi-select.component';
import { ButtonsComponent } from '../../../shared/buttons/buttons.component';
import { ShareItemsService } from '../../../services/share-feature/share-items.service';
import { forkJoin, lastValueFrom } from 'rxjs';
import * as PopupConstants from '../../../shared/constants/popup-constants';

@Component({
  selector: 'app-instrument-run-edit-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, SearchableMultiSelectComponent, ButtonsComponent],
  templateUrl: './instrument-run-edit-modal.component.html',
  styleUrl: './instrument-run-edit-modal.component.css',
})
export class InstrumentRunEditModalComponent implements OnInit {
  editForm = new FormGroup({
    groups: new FormControl<string[]>([]),
  });

  fullGroupsList: { GroupID: number; GroupName: string; IsPrimary: boolean }[] = [];
  groupOptions: string[] = [];
  initialSelectedGroups: string[] = [];
  disabledGroupOptions: string[] = [];
  isSubmitting = false;

  // Button Constants
  buttonCancel = PopupConstants.BUTTON_CANCEL;
  arialLabel = PopupConstants.ARIAL_LABEL;
  btnMat = PopupConstants.BTN_MAT;
  btnStyleText = PopupConstants.BTN_STYLE_TEXT;

  buttonSave = PopupConstants.BUTTON_SAVE;
  btnMatFlat = PopupConstants.BTN_MAT_FLAT;
  btnStyleFilledSmall = PopupConstants.BTN_STYLE_FILLED_SMALL;
  btnStyleFilledSmallDisabled = PopupConstants.BTN_STYLE_FILLED_SMALL_DISABLED;

  constructor(
    public dialogRef: MatDialogRef<InstrumentRunEditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public shareItemsService: ShareItemsService
  ) {}

  ngOnInit(): void {
    this.initializeGroupControl();
  }

  initializeGroupControl() {
    // Expecting data.runData.rawGroups from the parent
    this.fullGroupsList = this.data.runData.rawGroups || [];

    // Find primary group to disable it (cannot remove primary group)
    const primaryGroup = this.fullGroupsList.find((g: any) => g.IsPrimary);

    this.groupOptions = this.fullGroupsList.map((g) => g.GroupName);
    this.initialSelectedGroups = this.fullGroupsList.map((g) => g.GroupName);

    this.editForm.get('groups')?.setValue(this.initialSelectedGroups);

    if (primaryGroup) {
      this.disabledGroupOptions = [primaryGroup.GroupName];
    }
  }

  closePopup() {
    this.dialogRef.close({ event: 'CANCEL' });
  }

  async onEditSubmit() {
    if (this.editForm.valid) {
      this.isSubmitting = true;
      const currentSelection = this.editForm.get('groups')?.value || [];

      // Calculate removed groups
      const removedGroupNames = this.initialSelectedGroups.filter((name: string) => !currentSelection.includes(name));

      const apiCalls: any = [];
      const runId = this.data.runData.runID;

      // Process Removals
      if (removedGroupNames.length > 0) {
        const removedGroupIds = this.fullGroupsList
          .filter((g) => removedGroupNames.includes(g.GroupName))
          .map((g) => g.GroupID);

        removedGroupIds.forEach((groupId) => {
          // Assuming resource path is 'instrument-runs' based on your SharePopup usage
          apiCalls.push(this.shareItemsService.removeResourceFromGroup('instrument-runs', runId, groupId));
        });
      }

      if (apiCalls.length > 0) {
        try {
          await lastValueFrom(forkJoin(apiCalls));
          this.dialogRef.close({ event: 'RELOAD' });
        } catch (error) {
          console.error('Error removing groups', error);
          this.isSubmitting = false; // Allow retry if failed
        }
      } else {
        this.closePopup();
      }
    }
  }
}
